<template>
  <div class="lm-block">
    <c-tab :current="innerCurrent" type="default" @onChangeTab="onTabChanged" :tabs="innerTabs"></c-tab>
    <g-switch-list1
      :chip="chip"
      class="hori-list"
      v-for="(d, i) in data.horizontal"
      :key="'h' + i"
      :horizontal-type="3"
      :title="d.title"
      :columns="5"
      :selectRule="selectRule"
      :list="d.list"></g-switch-list1>
  </div>
</template>

<script>
  import mixin from '../mixins';
  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向

  import CTab from '../../c_tab'; // 横向

  export default {
    name: "gd_ha10-lm",
    mixins: [mixin],
    components: {
      CTab,
      GSwitchList1,
    },
    props: {
      selectRule: {
        type: Function,
        default: () => true
      },
      innerTabs: {
        type: Array,
        default() {
          return []
        }
      },
      current: {
        type: Number,
        default: 0
      }
    },
    watch: {
      current() {
        this.innerCurrent = this.current;
      },
      innerCurrent() {
        this.$emit('lm_change', this.innerCurrent);
      }
    },
    data() {
      return {
        innerCurrent: this.current
      }
    },
    methods: {
      onTabChanged(tab) {
        this.innerCurrent = tab.value;
        // 切换tab 更新数据
      }
    }
  }
</script>

<style scoped lang="stylus">
  .hori-list {
    margin-top 7px
  }
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/gd_ha10/lm.vue